import { TFocusMode } from './types'

export const INPUT_MAX_HEIGHT = 300
export const INPUT_MAX_HEIGHT_MOBILE = 150

export const FOCUS_MODE: TFocusMode = 'focus'
export const BLUR_MODE: TFocusMode = 'blur'
